import { createEmptySliceBase, injectTabSlice, toReducer } from '../sliceFactory';

const createProfileReducer = () => {
  const sliceBase = createEmptySliceBase({ name: 'profile' });
  const withTabs = injectTabSlice({ sliceBase });
  return toReducer(withTabs);
};

export default createProfileReducer;
